<!--Navbar-->
<nav class="navbar navbar-expand-lg py-3 navbar-dark">
  <div class="container">
    <!-- Navbar brand -->
    <a class="navbar-brand" href="javascript:;;" [routerLink]="['/']">Aquilone Onlus</a>

    <!-- Collapse button -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#basicExampleNav"
      aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible content -->
    <div class="collapse navbar-collapse" id="basicExampleNav">
      <!-- Links -->
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="javascript:;;" [routerLink]="['/']">HOME
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="jaascript:;;" [routerLink]="['/products/all-products']">PRESEPI</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="https://aquilonefarigliano.org" target="_blank">CHI SIAMO</a>
        </li>
      </ul>
      <!-- Links -->

      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <div>
            <a class="nav-link" href="javascript:;;" [routerLink]="['/products/cart-items']">
              <i class="fa fa-shopping-basket">
                <span class="mt-2">
                  {{ productService.getLocalCartProducts().length }}</span>
              </i>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- Collapsible content -->
</nav>
<!--/.Navbar-->